import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';
import { SubSink } from 'subsink';

import { MerchantAccountActions } from '@app/merchant-account/store/merchant-account.slice';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnDestroy, OnInit {
  @Input() id: string = '';
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() email: string = '';
  @Input() phoneNumber: string = '';
  @Input() regDate?: string;
  @Input() roles: string[] = [];

  private subs = new SubSink();

  isRemoveVisible: boolean = true;

  constructor(private store: Store) {}

  async ngOnInit(): Promise<void> {
    const user = await Auth.currentSession();
    if (user.getIdToken().payload['sub'] === this.id) {
      this.isRemoveVisible = false;
    }
  }

  delete(): void {
    this.store.dispatch(
      MerchantAccountActions.removeMerchantAdmin.trigger({ id: this.id })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
